import { Action, actionCreators } from "../actions";

export interface Store {
    loaded: boolean;
}

export function initialStore(): Store {
    return {
        loaded: false,
    };
}

export function update(store = initialStore(), action: Action): Store {
    switch (action.type) {
        case actionCreators.onSync.type: {
            return { ...store, loaded: true };
        }

        case actionCreators.onLogout.type: {
            return { ...store, loaded: false };
        }

        default: {
            return store;
        }
    }
}

export type OuterStore = { oauth: Store };

export function getIsLoaded(store: OuterStore) {
    return store.oauth.loaded;
}
